'use client'

export const usePreOpen = () => {
  const isPreOpen = process.env.NEXT_PUBLIC_DISABLE_PREOPEN === 'true'

  return {
    isPreOpen,
  }
}
